export interface UserBaseInfoParams
  extends Record<string, string | number | boolean | null | undefined> {
  username: string;
}

export interface UserBasicInfo {
  name: string;
  nickname: string;
  teamName: string;
  tenantName: string;
}

export interface ChangePasswordParams {
  oldPassword: string;
  newPassword: string;
}

export interface UserInfoParams
  extends Record<string, string | number | boolean | null | undefined> {
  uid: string | number;
}

export interface UserInfo {
  uid: number;
  empNo: string;
  email: string;
  instance?: string;
  name: string;
  teamId: number;
  teamName: string;
  jobName: string;
  rankName: string;
  isIFA: boolean;
  iaCode: string;
}
export enum RiskClass {
    HighRisk = "HIGH_RISK",
    LowRisk = "LOW_RISK",
    MediumRisk = "MEDIUM_RISK",
}

// ==================== 用户个性化配置相关 ====================

/**
 * 客户端类型
 */
export enum PreferenceClient {
  AdvisorSmartPortal = "ADVISOR_SMART_PORTAL",
  BrokerageBusinessManagement = "BROKERAGE_BUSINESS_MANAGEMENT",
  SmartApp = "SMART_APP",
  SmartH5 = "SMART_H5",
}

/**
 * 用户个性化配置
 */
export interface UserPreferenceConfigVO {
  id?: number;
  uid?: number;
  client?: PreferenceClient;
  configContent?: string[];
  createTime?: string;
  updateTime?: string;
  [property: string]: any;
}

/**
 * 保存用户个性化配置请求参数
 */
export interface UserPreferenceConfigDTO {
  configContent?: string[];
  [property: string]: any;
}
